import { gql } from '@apollo/client';

import type { FleetProducts } from '@cobliteam/common-types';

import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLCameraFleetFlagRequester {
  private queryGetCameraFleetFlag = gql`
    query getCameraFlag {
      hasCameraFlag
    }
  `;

  public getCameraFleetFlag = (): Promise<Boolean> =>
    graphQLRequester
      .query<{ hasCameraFlag: Boolean }>({
        query: this.queryGetCameraFleetFlag,
      })
      .then((result) => result.hasCameraFlag);

  private queryGetFleetProducts = gql`
    query getFleetProducts {
      fleetProducts {
        products {
          id
          name
        }
      }
    }
  `;

  public getFleetProducts = (): Promise<FleetProducts> =>
    graphQLRequester
      .query<{ fleetProducts: FleetProducts }>({
        query: this.queryGetFleetProducts,
      })
      .then((result) => {
        return result.fleetProducts;
      });
}

export default GraphQLCameraFleetFlagRequester;
